import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {Subject} from "rxjs";
import {DataTableDirective} from "angular-datatables";
import {ActivatedRoute} from "@angular/router";
import {NgxUiLoaderService} from "ngx-ui-loader";
import {AuditService} from "../services/audit.service";
import * as moment from "moment";
import {AuditUserViewModel} from "../models/audit-user-view-model";

@Component({
  selector: 'app-user-audit',
  templateUrl: './user-audit.component.html',
  styleUrls: ['./user-audit.component.scss']
})
export class UserAuditComponent implements OnInit {

  @ViewChild('content') content: ElementRef;

  public dtOptions: DataTables.Settings = {};
  public dtTrigger: Subject<boolean> = new Subject();
  public auditLogs: AuditUserViewModel[] = [];

  public merchantNumber: string;
  public currentDate: string;
  @ViewChild(DataTableDirective)
  public dtElement: DataTableDirective;
  dtInstance: Promise<DataTables.Api>;

  constructor(private _route: ActivatedRoute,
              private _ngxUiLoaderService: NgxUiLoaderService,
              private _auditService: AuditService) {

    const today = new Date();
    this.currentDate = moment(today).format('lll'); //'' + yyyy + '-' + mm + '-' + day;
  }

  ngOnInit() {
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
      search: {
        caseInsensitive: true
      }
    };
    this.init();
    this.reload();
  }

  public async initTable(selectedIndex: number): Promise<void> {

    if (selectedIndex == 2) {
      this.dtTrigger = new Subject();
      this.dtTrigger.next();
    }
  }

  private async init(): Promise<void> {

    this._ngxUiLoaderService.start();

    this.auditLogs = await this._auditService.GetUserLogs();

    this.dtTrigger.next();

    this._ngxUiLoaderService.stop();
  }

  public DownloadMerchantDetailsCsv(): void {
    const data = this.auditLogs;
    const replacer = (key, value) => (value === null ? '' : value); // specify how you want to handle null values here
    const header = Object.keys(data[0]);
    const csv = data.map((row) =>
      header
        .map((fieldName) => JSON.stringify(row[fieldName], replacer))
        .join(',')
    );
    csv.unshift(header.join(','));
    const csvArray = csv.join('\r\n');

    const a = document.createElement('a');
    const blob = new Blob([csvArray], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);

    a.href = url;
    a.download = ('Merchant_Audit_Trail_' + this.currentDate + ".csv");
    a.click();
    window.URL.revokeObjectURL(url);
    a.remove();
  }

  public print(): void {
    let printContents, popupWin;
    printContents = document.getElementById('content').innerHTML;
    popupWin = window.open('', '_blank', 'top=50,left=1,height=100%,width=auto');
    popupWin.document.open();
    popupWin.document.write(`
      <html>
        <head>
          <title>Print tab</title>
           <link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/css/bootstrap.min.css">
        </head>
        <body onload="window.print();window.close()">${printContents}</body>
      </html>`
    );
    popupWin.document.close();
  }

  ngOnDestroy(): void {
    // Do not forget to unsubscribe the event
    this.dtTrigger.unsubscribe();
    //this.subscription.unsubscribe();
  }
  reload() {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.ajax.reload()
    });
  }
}
